export default __webpack_public_path__ + "static/media/green.2eb5824a.jpg";